import React from 'react';

import { useIntl } from 'ha/i18n';

import { CommonCheckboxFilter } from 'ha/components/Filters/CommonCheckboxFilter';
import { CommonCheckboxTitleWithCount } from 'ha/components/Filters/CommonCheckboxTitleWithCount';

import { PriceFilterValue, PriceValue } from '../../types';

interface Props {
  value: PriceFilterValue;
  onChange: (value: PriceFilterValue) => void;
}

const PriceFilter: React.FC<Props> = ({ value, onChange }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      options={[
        {
          value: PriceValue.FREE,
          title: <CommonCheckboxTitleWithCount title={T('Free')} />,
          testLocator: 'Filter Free',
        },
        {
          value: PriceValue.DISCOUNTED,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('ukr_response.search.price_discounted')}
            />
          ),
          testLocator: 'Filter Discounted',
        },
      ]}
      value={value}
      onChange={onChange}
    />
  );
};

export { PriceFilter };
